const Frame = ({ title, children }) => (
  <div className="overflow-hidden rounded-lg border border-white/10 bg-[#0a1322] text-slate-200 shadow-[0_40px_100px_-40px_rgba(15,23,42,0.9)]">
    <div className="flex items-center justify-between border-b border-white/10 px-4 py-2.5">
      <span className="font-mono text-[11px] text-slate-400">{title}</span>
      <span className="rounded border border-white/15 px-1.5 py-0.5 font-mono text-[10.5px] uppercase tracking-wider text-slate-300">sample data</span>
    </div>
    <div className="p-5">{children}</div>
  </div>
);

const Workflow = () => (
  <Frame title="workflow-board">
    <div className="grid grid-cols-3 gap-3">
      {[["Requested", ["Vendor onboarding", "Budget change"]], ["In review", ["Leave request", "New contract"]], ["Approved", ["Purchase order", "Access request"]]].map(([col, items], ci) => (
        <div key={col}>
          <p className="mb-2 flex items-center gap-1.5 text-[11px] font-semibold text-slate-400"><span className={`h-1.5 w-1.5 rounded-full ${["bg-amber-300", "bg-cyan-300", "bg-emerald-300"][ci]}`} />{col}</p>
          {items.map((t) => <div key={t} className="mb-2 rounded border border-white/10 bg-white/[0.03] p-2.5 text-[11.5px] leading-snug">{t}<span className="mt-2 block h-1 w-2/3 rounded bg-white/10" /></div>)}
        </div>
      ))}
    </div>
  </Frame>
);

const Fintech = () => (
  <Frame title="transactions">
    <div className="space-y-0 font-mono text-[11.5px]">
      {[["TXN-20931", "Mobile recharge", "₹ 299", "SUCCESS", "text-emerald-300"], ["TXN-20932", "DTH recharge", "₹ 450", "PENDING", "text-amber-300"], ["TXN-20933", "Electricity bill", "₹ 1,280", "SUCCESS", "text-emerald-300"], ["TXN-20934", "Mobile recharge", "₹ 199", "REFUNDED", "text-violet-300"]].map((r) => (
        <div key={r[0]} className="grid grid-cols-[1fr_1.3fr_auto] items-center gap-2 border-b border-white/5 py-2.5 last:border-0 sm:grid-cols-[1fr_1.3fr_0.8fr_auto]">
          <span className="text-slate-400">{r[0]}</span><span className="truncate text-slate-200">{r[1]}</span><span className="hidden text-right text-slate-200 sm:block">{r[2]}</span><span className={`text-right ${r[4]}`}>{r[3]}</span>
        </div>
      ))}
    </div>
    <div className="mt-4 flex items-center justify-between rounded border border-white/10 px-3 py-2 text-[11.5px]"><span className="text-slate-400">Daily reconciliation</span><span className="text-cyan-300">matched · 2 flagged</span></div>
  </Frame>
);

const Ops = () => (
  <Frame title="operations-suite">
    <div className="flex h-24 items-end gap-2">
      {[40, 65, 52, 80, 70, 92, 60].map((h, i) => <span key={i} style={{ height: `${h}%` }} className={`flex-1 rounded-t-sm ${i === 5 ? "grad-line" : "bg-white/15"}`} />)}
    </div>
    <div className="mt-4 grid grid-cols-2 gap-2 text-[11.5px]">
      {[["Stock alerts", "3 items low"], ["Approvals", "5 waiting"], ["Orders today", "Sample"], ["Reports", "Scheduled"]].map(([a, b]) => (
        <div key={a} className="rounded border border-white/10 px-3 py-2"><p className="text-slate-400">{a}</p><p className="mt-0.5 font-semibold text-slate-100">{b}</p></div>
      ))}
    </div>
  </Frame>
);

const MAP = { workflow: Workflow, fintech: Fintech, ops: Ops };
export const WorkMockup = ({ type }) => {
  const C = MAP[type] || Workflow;
  return <C />;
};
